import {Component, Input, OnInit} from '@angular/core';
import {RouterLink} from '@angular/router';
import {IonicModule} from '@ionic/angular';
import {NgIf} from '@angular/common';

@Component({
  selector: 'app-product-card',
  templateUrl: './product-card.component.html',
  styleUrls: ['./product-card.component.scss'],
  standalone: true,
  imports: [
    RouterLink,
    IonicModule,
    NgIf,
  ],
})
export class ProductCardComponent implements OnInit {
  @Input() data: any;

  constructor() {
  }

  ngOnInit() {
  }

}
